import { FC } from 'react';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import { Tiempos } from 'fonts';
import SectionWithVideo from 'components/commercetools-ui/organisms/content/cms-components/section-with-video';
import SectionWithImageAndText from 'components/commercetools-ui/organisms/content/cms-components/section-with-image-and-text';
import SectionWithHeadingAndDescription from 'components/commercetools-ui/organisms/content/cms-components/section-with-heading-and-description';
import SectionWithCards from 'components/commercetools-ui/organisms/content/cms-components/section-with-cards';
import SectionWithBannerSlider from 'components/commercetools-ui/organisms/content/cms-components/section-with-banner-slider';

export type CmsMaterContainerProps = {
  data?: any;
};
const CmsMaterContainer: FC<CmsMaterContainerProps> = ({ data }) => {

  const ComponentRegistry: { [key: string]: React.ElementType } = {
    section_with_image_and_text: SectionWithImageAndText,
    section_with_video: SectionWithVideo,
    section_with_heading_description: SectionWithHeadingAndDescription,
    section_with_cards:SectionWithCards,
    section_with_banner_slider:SectionWithBannerSlider
  };

  const renderContentStackComponents = () => {
    const componentList = [];
    const { sections = [] } = data;
    for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const sectionId = Object.keys(section)?.[0] ?? '';
        const Component = ComponentRegistry[sectionId];
        const dataToPass = section[Object.keys(section)?.[0]];
        if(Component && dataToPass){          
          componentList.push(<Component content={dataToPass} />);
        }
    }
    return componentList;
  }

  const generateBreadcrumbs = () => {
    return data.breadcrumbs.links
    .filter((link: any) => link.title?.trim() && link.title?.trim().toLowerCase() != 'home')
    .map((link: any, index: number) => {
      const content = <span key={index} className={`text-14 font-normal leading-4 text-[#666] ${Tiempos.className}`}>{link.title}</span>;
      return link.href ? <Link key={index} link={link.href}>{content}</Link> : content;
    });
  };
  
  return (
    <>
        {data.breadcrumbs.links[0].title &&
          <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
          <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
            <Link link={'/'}>
              <HomeIcon className="mt-6 w-20" />
            </Link>
            {generateBreadcrumbs()}
          </Breadcrumb>
          </div>
        }
        {renderContentStackComponents()}
    </>
  );
};
export default CmsMaterContainer;
